export const translations = {
  'Too many hints. The next game will not be available.': 'Too many hints. The next game will not be available.',
  'Too many hints. Starting the same game in {seconds} seconds.': 'Too many hints. Starting the same game in {seconds} seconds.',
  'Good, but letters selection mode is required to pass. Starting the same game in {seconds} seconds.': 'Good, but letters selection mode is required to pass. Starting the same game in {seconds} seconds.',
  Autoplay: 'Autoplay',
  'At least one word not solved. The next game will not be available.': 'At least one word not solved. The next game will not be available.',
  'Autoplay site sounds': 'Autoplay site sounds',
  'Start new game in explore mode.': 'Start new game in explore mode.',
  'Image selection': 'Image selection',
  'Letters selection': 'Letters selection',
  'Tell again': 'Tell again',
  'Report an issue': 'Report an issue',
  Contribute: 'Contribute',
  'Amazing. The next game will start in {seconds} seconds.': 'Amazing. The next game will start in {seconds} seconds.',
  'Game skipped. Starting the next game in {seconds} seconds.': 'Game skipped. Starting the next game in {seconds} seconds.',
  'Amazing. New game will start in {seconds} seconds.': 'Amazing. New game will start in {seconds} seconds.',
  Skip: 'Skip',
  'Warning: this is alpha version of the app. Please be ready to lose your progress in explore mode once. Sorry for inconvenience.': 'Warning: this is alpha version of the app. Please be ready to lose your progress in explore mode once. Sorry for inconvenience.',
  Help: 'Help',
  Leave: 'Leave',
  Contest: 'Contest',
  'Find rival': 'Find rival',
  'Start train': 'Start train',
  Train: 'Train',
  Amazing: 'Amazing',
  'Amazing. New round will start in {seconds} seconds.': 'Amazing. New round will start in {seconds} seconds.',
  'Well, but not enough. Try again in {seconds} seconds.': 'Well, but not enough. Try again in {seconds} seconds.',
  'Very well. New round will start in {seconds} seconds.': 'Very well. New round will start in {seconds} seconds.',
  'Very well.': 'Very well.',
  'Well done.': 'Well done.',
  Well: 'Well',
  'So bad. You can do better!': 'So bad. You can do better!',
  Explore: 'Explore',
  'What?': 'What?',
  'You won!': 'You won!',
  'Solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',
  'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.': 'Hints limit exceeded. Try to solve {firstUnsolvedGameTopic}#{firstUnsolvedGameTopicSet} again to reach the {secondUnsolvedGameTopic}#{secondUnsolvedGameTopicSet}.',

  // levels
  Simple: 'Simple',
  Normal: 'Normal',
  Hard: 'Hard'
}
